// @generated by protoc-gen-es v2.12.1 with parameter "target=ts"
// @generated from file tabgraph/v1/graph.proto (package tabgraph.v1, syntax proto3)
/* eslint-disable */

// Package tabgraph.v1 defines the canonical data types and services for the
// tabgraph application.

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { PageInfo } from "./common_pb";
import { file_tabgraph_v1_common } from "./common_pb";
import type { Session } from "./session_pb";
import { file_tabgraph_v1_session } from "./session_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file tabgraph/v1/graph.proto.
 */
export const file_tabgraph_v1_graph: GenFile = /*@__PURE__*/
  fileDesc("Chd0YWJncmFwaC92MS9ncmFwaC5wcm90bxILdGFiZ3JhcGgudjEi7gEKBE5vZGUSCgoCaWQYASABKAkSEgoKc2Vzc2lvbl9pZBgCIAEoCRIVCg1jYW5vbmljYWxfdXJsGAMgASgJEhAKCHVybF9ob3N0GAQgASgJEiMKBHBhZ2UYBSABKAsyFS50YWJncmFwaC52MS5QYWdlSW5mbxIxCg1maXJzdF9zZWVuX2F0GAYgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIwCgxsYXN0X3NlZW5fYXQYByABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhMKC3Zpc2l0X2NvdW50GAggASgFIsoBCgVWaXNpdBIKCgJpZBgBIAEoCRIPCgdub2RlX2lkGAIgASgJEhUKDWNocm9tZV90YWJfaWQYAyABKAMSLwoKdHJhbnNpdGlvbhgEIAEoDjIbLnRhYmdyYXBoLnYxLlRyYW5zaXRpb25UeXBlEi0KCW9wZW5lZF9hdBgFIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLQoJY2xvc2VkX2F0GAYgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCKJAgoERWRnZRIKCgJpZBgBIAEoCRISCgpzZXNzaW9uX2lkGAIgASgJEhkKDGZyb21fbm9kZV9pZBgDIAEoCUgAiAEBEhIKCnRvX25vZGVfaWQYBCABKAkSIwoEdHlwZRgFIAEoDjIVLnRhYmdyYXBoLnYxLkVkZ2VUeXBlEjEKDWZpcnN0X3NlZW5fYXQYBiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEjAKDGxhc3Rfc2Vlbl9hdBgHIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASFwoPdHJhdmVyc2FsX2NvdW50GAggASgFQg8KDV9mcm9tX25vZGVfaWQilgEKBUdyYXBoEiUKB3Nlc3Npb24YASABKAsyFC50YWJncmFwaC52MS5TZXNzaW9uEiAKBW5vZGVzGAIgAygLMhEudGFiZ3JhcGgudjEuTm9kZRIgCgVlZGdlcxgDIAMoCzIRLnRhYmdyYXBoLnYxLkVkZ2USIgoGdmlzaXRzGAQgAygLMhIudGFiZ3JhcGgudjEuVmlzaXQqhAIKDlRyYW5zaXRpb25UeXBlEh8KG1RSQU5TSVRJT05fVFlQRV9VTlNQRUNJRklFRBAAEhgKFFRSQU5TSVRJT05fVFlQRV9MSU5LEAESGQoVVFJBTlNJVElPTl9UWVBFX1RZUEVEEAISGgoWVFJBTlNJVElPTl9UWVBFX1JFTE9BRBADEh8KG1RSQU5TSVRJT05fVFlQRV9GT1JNX1NVQk1JVBAEEiEKHVRSQU5TSVRJT05fVFlQRV9BVVRPX0JPT0tNQVJLEAUSHAoYVFJBTlNJVElPTl9UWVBFX1JFU1RPUkVEEAYSHgoaVFJBTlNJVElPTl9UWVBFX1BVU0hfU1RBVEUQByqRAQoIRWRnZVR5cGUSGQoVRURHRV9UWVBFX1VOU1BFQ0lGSUVEEAASGAoURURHRV9UWVBFX09QRU5FRF9UQUIQARIXChNFREdFX1RZUEVfTkFWSUdBVEVEEAISHwobRURHRV9UWVBFX0hJU1RPUllfUFVTSFNUQVRFEAMSFgoSRURHRV9UWVBFX1JFU1RPUkVEEARCR1pFZ2l0aHViLmNvbS9zdHJhdHVzc3R1ZGlvcy90YWJncmFwaC9iYWNrZW5kL2dlbi90YWJncmFwaC92MTt0YWJncmFwaHYxYgZwcm90bzM", [file_google_protobuf_timestamp, file_tabgraph_v1_common, file_tabgraph_v1_session]);

/**
 * Node represents a unique page within a session, keyed by (session_id,
 * canonical_url). Multiple visits to the same canonical URL merge into one
 * node, enabling cycles and multi-parent/multi-child topologies.
 *
 * @generated from message tabgraph.v1.Node
 */
export type Node = Message<"tabgraph.v1.Node"> & {
  /**
   * id is the unique node identifier, prefixed nod_<ksuid>.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * session_id is the owning session.
   *
   * @generated from field: string session_id = 2;
   */
  sessionId: string;

  /**
   * canonical_url is the normalised URL; unique per session.
   *
   * @generated from field: string canonical_url = 3;
   */
  canonicalUrl: string;

  /**
   * url_host is the hostname component of canonical_url, denormalised for
   * efficient host-based queries.
   *
   * @generated from field: string url_host = 4;
   */
  urlHost: string;

  /**
   * page carries the displayable page metadata (title, raw URL, favicon).
   *
   * @generated from field: tabgraph.v1.PageInfo page = 5;
   */
  page?: PageInfo | undefined;

  /**
   * first_seen_at is when this URL was first visited in the session.
   *
   * @generated from field: google.protobuf.Timestamp first_seen_at = 6;
   */
  firstSeenAt?: Timestamp | undefined;

  /**
   * last_seen_at is when this URL was most recently visited in the session.
   *
   * @generated from field: google.protobuf.Timestamp last_seen_at = 7;
   */
  lastSeenAt?: Timestamp | undefined;

  /**
   * visit_count is the number of times this URL was visited within the session.
   *
   * @generated from field: int32 visit_count = 8;
   */
  visitCount: number;
};

/**
 * Describes the message tabgraph.v1.Node.
 * Use `create(NodeSchema)` to create a new message.
 */
export const NodeSchema: GenMessage<Node> = /*@__PURE__*/
  messageDesc(file_tabgraph_v1_graph, 0);

/**
 * Visit records a single tab-level occurrence of a node. A node accumulates
 * multiple visits without duplicating graph nodes, preserving the full
 * temporal and tab record for audit/debug purposes.
 *
 * @generated from message tabgraph.v1.Visit
 */
export type Visit = Message<"tabgraph.v1.Visit"> & {
  /**
   * id is the unique visit identifier, prefixed vis_<ksuid>.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * node_id is the parent node this visit belongs to.
   *
   * @generated from field: string node_id = 2;
   */
  nodeId: string;

  /**
   * chrome_tab_id is the Chrome tab identifier for this visit.
   *
   * @generated from field: int64 chrome_tab_id = 3;
   */
  chromeTabId: bigint;

  /**
   * transition describes how the browser arrived at this URL.
   *
   * @generated from field: tabgraph.v1.TransitionType transition = 4;
   */
  transition: TransitionType;

  /**
   * opened_at is when the tab was opened or navigated to this URL.
   *
   * @generated from field: google.protobuf.Timestamp opened_at = 5;
   */
  openedAt?: Timestamp | undefined;

  /**
   * closed_at is when the tab was closed; unset while the tab is still open.
   *
   * @generated from field: google.protobuf.Timestamp closed_at = 6;
   */
  closedAt?: Timestamp | undefined;
};

/**
 * Describes the message tabgraph.v1.Visit.
 * Use `create(VisitSchema)` to create a new message.
 */
export const VisitSchema: GenMessage<Visit> = /*@__PURE__*/
  messageDesc(file_tabgraph_v1_graph, 1);

/**
 * Edge represents a directed navigation between two nodes within a session.
 * The uniqueness key is (session_id, from_node_id, to_node_id, type); repeated
 * traversals of the same path increment traversal_count rather than creating
 * new edges. Self-loops (from_node_id == to_node_id) are valid.
 *
 * @generated from message tabgraph.v1.Edge
 */
export type Edge = Message<"tabgraph.v1.Edge"> & {
  /**
   * id is the unique edge identifier, prefixed edg_<ksuid>.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * session_id is the owning session.
   *
   * @generated from field: string session_id = 2;
   */
  sessionId: string;

  /**
   * from_node_id is the source node; unset for root edges (first navigation
   * with no known opener).
   *
   * @generated from field: optional string from_node_id = 3;
   */
  fromNodeId?: string | undefined;

  /**
   * to_node_id is the destination node.
   *
   * @generated from field: string to_node_id = 4;
   */
  toNodeId: string;

  /**
   * type describes the mechanism by which this edge was created.
   *
   * @generated from field: tabgraph.v1.EdgeType type = 5;
   */
  type: EdgeType;

  /**
   * first_seen_at is when this directed pair was first traversed.
   *
   * @generated from field: google.protobuf.Timestamp first_seen_at = 6;
   */
  firstSeenAt?: Timestamp | undefined;

  /**
   * last_seen_at is when this directed pair was most recently traversed.
   *
   * @generated from field: google.protobuf.Timestamp last_seen_at = 7;
   */
  lastSeenAt?: Timestamp | undefined;

  /**
   * traversal_count is the number of times this directed pair has been
   * traversed in the session.
   *
   * @generated from field: int32 traversal_count = 8;
   */
  traversalCount: number;
};

/**
 * Describes the message tabgraph.v1.Edge.
 * Use `create(EdgeSchema)` to create a new message.
 */
export const EdgeSchema: GenMessage<Edge> = /*@__PURE__*/
  messageDesc(file_tabgraph_v1_graph, 2);

/**
 * Graph is the full representation of a session, combining the session
 * metadata with its nodes, edges, and optional per-visit records.
 *
 * @generated from message tabgraph.v1.Graph
 */
export type Graph = Message<"tabgraph.v1.Graph"> & {
  /**
   * session carries the session metadata.
   *
   * @generated from field: tabgraph.v1.Session session = 1;
   */
  session?: Session | undefined;

  /**
   * nodes is the complete set of unique pages visited in the session.
   *
   * @generated from field: repeated tabgraph.v1.Node nodes = 2;
   */
  nodes: Node[];

  /**
   * edges is the complete set of directed transitions between nodes.
   *
   * @generated from field: repeated tabgraph.v1.Edge edges = 3;
   */
  edges: Edge[];

  /**
   * visits carries per-tab occurrence records. The UI may choose to display
   * or ignore these; they are included for completeness and audit purposes.
   *
   * @generated from field: repeated tabgraph.v1.Visit visits = 4;
   */
  visits: Visit[];
};

/**
 * Describes the message tabgraph.v1.Graph.
 * Use `create(GraphSchema)` to create a new message.
 */
export const GraphSchema: GenMessage<Graph> = /*@__PURE__*/
  messageDesc(file_tabgraph_v1_graph, 3);

/**
 * TransitionType mirrors Chrome's webNavigation transition types, capturing
 * how the browser arrived at a URL.
 *
 * @generated from enum tabgraph.v1.TransitionType
 */
export enum TransitionType {
  /**
   * TRANSITION_TYPE_UNSPECIFIED is the zero value; treat as unknown.
   *
   * @generated from enum value: TRANSITION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * TRANSITION_TYPE_LINK indicates the user clicked a link.
   *
   * @generated from enum value: TRANSITION_TYPE_LINK = 1;
   */
  LINK = 1,

  /**
   * TRANSITION_TYPE_TYPED indicates the user typed the URL directly.
   *
   * @generated from enum value: TRANSITION_TYPE_TYPED = 2;
   */
  TYPED = 2,

  /**
   * TRANSITION_TYPE_RELOAD indicates a page reload.
   *
   * @generated from enum value: TRANSITION_TYPE_RELOAD = 3;
   */
  RELOAD = 3,

  /**
   * TRANSITION_TYPE_FORM_SUBMIT indicates a form submission navigated the tab.
   *
   * @generated from enum value: TRANSITION_TYPE_FORM_SUBMIT = 4;
   */
  FORM_SUBMIT = 4,

  /**
   * TRANSITION_TYPE_AUTO_BOOKMARK indicates navigation from a bookmark.
   *
   * @generated from enum value: TRANSITION_TYPE_AUTO_BOOKMARK = 5;
   */
  AUTO_BOOKMARK = 5,

  /**
   * TRANSITION_TYPE_RESTORED indicates the tab was restored from a prior session.
   *
   * @generated from enum value: TRANSITION_TYPE_RESTORED = 6;
   */
  RESTORED = 6,

  /**
   * TRANSITION_TYPE_PUSH_STATE indicates a SPA history.pushState navigation.
   *
   * @generated from enum value: TRANSITION_TYPE_PUSH_STATE = 7;
   */
  PUSH_STATE = 7,
}

/**
 * Describes the enum tabgraph.v1.TransitionType.
 */
export const TransitionTypeSchema: GenEnum<TransitionType> = /*@__PURE__*/
  enumDesc(file_tabgraph_v1_graph, 0);

/**
 * EdgeType describes the mechanism by which a directed edge was created.
 *
 * @generated from enum tabgraph.v1.EdgeType
 */
export enum EdgeType {
  /**
   * EDGE_TYPE_UNSPECIFIED is the zero value; treat as unknown.
   *
   * @generated from enum value: EDGE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * EDGE_TYPE_OPENED_TAB indicates a new tab was opened from an existing tab
   * (chrome.tabs.onCreated with openerTabId set).
   *
   * @generated from enum value: EDGE_TYPE_OPENED_TAB = 1;
   */
  OPENED_TAB = 1,

  /**
   * EDGE_TYPE_NAVIGATED indicates an in-tab navigation
   * (webNavigation.onCommitted, top frame).
   *
   * @generated from enum value: EDGE_TYPE_NAVIGATED = 2;
   */
  NAVIGATED = 2,

  /**
   * EDGE_TYPE_HISTORY_PUSHSTATE indicates a SPA client-side route change
   * (webNavigation.onHistoryStateUpdated).
   *
   * @generated from enum value: EDGE_TYPE_HISTORY_PUSHSTATE = 3;
   */
  HISTORY_PUSHSTATE = 3,

  /**
   * EDGE_TYPE_RESTORED indicates a Chrome session-restore with no real opener.
   *
   * @generated from enum value: EDGE_TYPE_RESTORED = 4;
   */
  RESTORED = 4,
}

/**
 * Describes the enum tabgraph.v1.EdgeType.
 */
export const EdgeTypeSchema: GenEnum<EdgeType> = /*@__PURE__*/
  enumDesc(file_tabgraph_v1_graph, 1);

